/* eslint-disable react/no-array-index-key */
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { useAuthenticationContext, useLangContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { useGetSystemMessagesQuery } from '../../services/api';
import CalloutComponent from './CalloutComponent';
import NotificationComponent from './NotificationComponent';

const SystemMessagesComponent: FC = () => {
  const lang = useLangContext();
  const authenticated = useAuthenticationContext();
  // eslint-disable-next-line max-len

  const { data: systemMessages } = useGetSystemMessagesQuery({
    lang,
    anonymous: !authenticated,
  });

  if ((systemMessages || []).length === 0) {
    return null;
  }

  const renderCallouts = (systemMessages || []).filter(
    (msg) => msg.callout,
  ).map((msg) => createPortal(
    <CalloutComponent key={msg.id} systemMessage={msg} />,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    document.querySelector('.page__post-header')!,
  ));

  const renderNotifications = (systemMessages || []).filter(
    (msg) => msg.notification,
  ).map((msg) => (
    <NotificationComponent
      key={msg.id}
      systemMessage={msg}
    />
  ));

  return (
    <>
      {renderCallouts}
      {
        (systemMessages || []).filter((msg) => msg.notification).length > 0 && (
          <div className="page__content__block page__content__block--center-align-items">
            <div className="box box--constrain-width theme--background-secondary typography--dense" style={{ padding: 0 }}>
              {renderNotifications}
            </div>
          </div>
        )
      }
    </>
  );
};

SystemMessagesComponent.displayName = 'SystemMessagesComponent';
export default SystemMessagesComponent;
